import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

export const getBudgetOverviews = createAsyncThunk(
  "report/getBudgetOverviews",
  async ({ budget, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/summary?budget=${budget}&year=${year}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getCapitalExpenditureByProject = createAsyncThunk(
  "report/getCapitalExpenditureByProject",
  async ({ budget, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/projects?budget=${budget}&year=${year}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

//REPORT BY MDAs
export const reportbymdas = createAsyncThunk(
  "report/reportbymdas",
  async ({ year, type, budget }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/flow?budget=${budget}&year=${year}&type=${type}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT BY ADMINISTRATIVE SEGMENTs
export const reportbyAdminSegment = createAsyncThunk(
  "report/reportbyAdminSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/admin?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

//REPORT BY ECONOMIC SEGMENTs
export const reportbyEconomicSegment = createAsyncThunk(
  "report/reportbyEconomicSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/economic?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT BY FUNDS SEGMENTs
export const reportbyFundsSegment = createAsyncThunk(
  "report/reportbyFundsSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/fund?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT BY FUNCTION SEGMENTs
export const reportbyFunctionSegment = createAsyncThunk(
  "report/reportbyFunctionSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/function?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT BY LOCATION SEGMENTs
export const reportbyLocationSegment = createAsyncThunk(
  "report/reportbyLocationSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/location?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT BY PROGRAMME SEGMENTs
export const reportbyProgrammeSegment = createAsyncThunk(
  "report/reportbyProgrammeSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/programme?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT BY PROJECTS SEGMENTs
export const reportbyProjectsSegment = createAsyncThunk(
  "report/reportbyProjectsSegment",
  async ({ year, type, budget, category }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/projects?budget=${budget}&year=${year}&type=${type}&category=${category}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//REPORT On REVENUE BY ITEM
export const reportbyItem = createAsyncThunk(
  "report/reportbyItem",
  async ({ year, budget }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/reports/main/budget/capitalreceipts?budget=${budget}&year=${year}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const budgetsummary = createAsyncThunk(
  "report/budgetsummary",
  async ({ budget, mdabudgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v1/report/budget/summary?budget=${budget}&budgets=${mdabudgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const mdabudgetsummary = createAsyncThunk(
  "report/mdabudgetsummary",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/report/budget/summary`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const subheadbudgetsummary = createAsyncThunk(
  "report/subheadbudgetsummary",
  async ({ budget, mdabudgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v1/report/subhead/summary?budget=${budget}&budgets=${mdabudgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const budgetbreakdown = createAsyncThunk(
  "report/budgetbreakdown",
  async ({ budget, mdabudgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v1/report/budget/entries?budget=${budget}&budgets=${mdabudgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
const initialState = {
  data: null,
  loading: false,
  breakdown: null,
  summary: null,
  mdasummary: null,
  subheadloading: false,
  subheadsummary: null,
  tabs: null,
  tabloading: false,
  overviews: null,
  overviewloading: false,
  revenueoverviews: null,
  revenueoverviewloading: false,
  capitalreceiptoverviews: null,
  capitalreceiptoverviewloading: false,
  capitalexpenditureoverviews: null,
  capitalexpenditureoverviewloading: false,
  overheadoverviews: null,
  overheadoverviewloading: false,
  personneloverviews: null,
  personneloverviewloading: false,
}

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //BUDGET OVERVIEW
    builder.addCase(getBudgetOverviews.pending, (state) => {
      state.overviewloading = true
      state.overviews = null
    })
    builder.addCase(getBudgetOverviews.fulfilled, (state, { payload }) => {
      state.overviewloading = false
      state.overviews = payload.data
    })
    builder.addCase(getBudgetOverviews.rejected, (state) => {
      state.overviewloading = false
      state.overviews = null
    })
    builder.addCase(getCapitalExpenditureByProject.pending, (state) => {
      state.overviewloading = true
      state.data = null
    })
    builder.addCase(
      getCapitalExpenditureByProject.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getCapitalExpenditureByProject.rejected, (state) => {
      state.overviewloading = false
      state.data = null
    })

    //REPORT BY MDAS
    builder.addCase(reportbymdas.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbymdas.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbymdas.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY ADMINISTRATIVE SEGMENT
    builder.addCase(reportbyAdminSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyAdminSegment.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyAdminSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY ECONOMIC SEGMENT
    builder.addCase(reportbyEconomicSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyEconomicSegment.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyEconomicSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY FUNDS SEGMENT
    builder.addCase(reportbyFundsSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyFundsSegment.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyFundsSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY FUNCTION SEGMENT
    builder.addCase(reportbyFunctionSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyFunctionSegment.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyFunctionSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY LOCATIONS SEGMENT
    builder.addCase(reportbyLocationSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyLocationSegment.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyLocationSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY PROGRAMME SEGMENT
    builder.addCase(reportbyProgrammeSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      reportbyProgrammeSegment.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(reportbyProgrammeSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT BY PROJECTS SEGMENT
    builder.addCase(reportbyProjectsSegment.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyProjectsSegment.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyProjectsSegment.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //REPORT ON REVENUE BY ITEMS
    builder.addCase(reportbyItem.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(reportbyItem.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(reportbyItem.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    //BUDGET SUMMARIES
    builder.addCase(budgetsummary.pending, (state) => {
      state.loading = true
      state.summary = null
    })
    builder.addCase(budgetsummary.fulfilled, (state, { payload }) => {
      state.loading = false
      state.summary = payload.data
    })
    builder.addCase(budgetsummary.rejected, (state) => {
      state.loading = false
      state.summary = null
    })
    builder.addCase(mdabudgetsummary.pending, (state) => {
      state.loading = true
      state.mdasummary = null
    })
    builder.addCase(mdabudgetsummary.fulfilled, (state, { payload }) => {
      state.loading = false
      state.mdasummary = payload.data
    })
    builder.addCase(mdabudgetsummary.rejected, (state) => {
      state.loading = false
      state.mdasummary = null
    })
    builder.addCase(subheadbudgetsummary.pending, (state) => {
      state.subheadloading = true
      state.subheadsummary = null
    })
    builder.addCase(subheadbudgetsummary.fulfilled, (state, { payload }) => {
      state.subheadloading = false
      state.subheadsummary = payload.data
    })
    builder.addCase(subheadbudgetsummary.rejected, (state) => {
      state.subheadloading = false
      state.subheadsummary = null
    })
    builder.addCase(budgetbreakdown.pending, (state) => {
      state.loading = true
      state.breakdown = null
    })
    builder.addCase(budgetbreakdown.fulfilled, (state, { payload }) => {
      state.loading = false
      state.breakdown = payload.data
    })
    builder.addCase(budgetbreakdown.rejected, (state) => {
      state.loading = false
      state.breakdown = null
    })
  },
})

export default reportSlice.reducer
